export default __webpack_public_path__ + "static/media/pickle.eadd4eca.png";